import React, { useEffect, useRef } from "react";
import Loader from "../../../../shared/components/general/Loader";

interface RevenueAuthController {
    state: {
        isAuthenticated: boolean;
        accessToken?: string;
        apiKeyAuth?: boolean;
    };
    refreshToken: () => Promise<any> | void;
}

interface RevenueAccessGateProps {
    authContainer: RevenueAuthController;
}

const RevenueAccessGate: React.FC<RevenueAccessGateProps> = ({
    authContainer,
    children,
}) => {
    const refreshStarted = useRef(false);
    const hasRequestAuthorization = !!authContainer.state.accessToken || !!authContainer.state.apiKeyAuth;

    useEffect(() => {
        if (hasRequestAuthorization) {
            refreshStarted.current = false;
            return;
        }

        if (!authContainer.state.isAuthenticated || refreshStarted.current) return;

        refreshStarted.current = true;
        const refreshResult = authContainer.refreshToken();
        if (refreshResult) {
            refreshResult.catch(() => undefined);
        }
    }, [
        authContainer,
        authContainer.state.isAuthenticated,
        hasRequestAuthorization,
    ]);

    if (!hasRequestAuthorization) {
        return <Loader />;
    }

    return <>{children}</>;
};

export default RevenueAccessGate;
